<!-- eslint-disable -->
<template lang="pug">
    .box
        .box-body
            .box-body__title {{ $i18n.t('battle.battle_selectGameType_button_achievementsList') }}
            cs-loader(v-if="isLoading")
            progress-bar(
                v-if="!isLoading"
                :number-of-stars="stars"
            )
            .box-body__achievements-block(v-if="!isLoading && achievementsExists")
                achievement-item(
                    v-for="achievement in achievements"
                    :achievement="achievement"
                    :key="achievement.id"
                )
</template>
<script>
    /*eslint-disable*/
    import ProgressBar from './ProgressBar.vue';
    import AchievementItem from './AchievementItem.vue';
    import AchievementsApi from '../../../api/achievements/achievements';
    import UserApi from '../../../api/user/user';
    import { mapState } from 'vuex';
    import { kebabCase } from 'lodash';

    export default {
        components: {
            ProgressBar,
            AchievementItem,
        },
        data() {
            return {
                achievements: [],
                stars: 0,
                isLoading: false,
            };
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                AchievementsApi.getAchievements({ course_type: kebabCase(this.course) })
                    .then(achievements => {
                        this.achievements = Object.values(achievements);
                        this.isLoading = false;
                    })
                    .catch(err => {
                        this.isLoading = false;
                    });
                this.isLoading = true;
                if (this.user.type === 'student') {
                    UserApi.getStars({ course_type: kebabCase(this.course) })
                        .then(stars => {
                            this.stars = stars;
                            this.isLoading = false;
                        })
                        .catch(err => {
                            this.isLoading = false;
                        });
                }
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                course: state => state.trainer.course,
            }),
            achievementsExists() {
                return !!(this.achievements && this.achievements.length);
            },
        },
    };
</script>
<style lang="scss" scoped>
    .box {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border-radius: 0;
        background: #ffffff;
        box-shadow: 0 0 54px #51a552;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px 20px;
        @include media($sm) {
            border-radius: 40px;
            padding: 30px;
        }
        @media screen and (max-width: 575px) {
            border-radius: 0;
            padding: 0;
            box-shadow: none;
        }
        @include media($md) {
            margin-bottom: 65px;
        }
        @include media($xl) {
            margin-bottom: 15px;
        }
    }

    .box-body {
        width: 100%;
        height: 100%;
    }

    .box-body__title {
        white-space: nowrap;
        text-align: center;
        font-family: 'Appetite';
        font-size: 42px;
        line-height: 42px;
        color: #2187ff;
        margin-bottom: 15px;
        @media screen and (max-width: 600px) {
            font-size: 36px;
            white-space: normal;
        }
    }

    .box-body__achievements-block {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
    }
</style>
